import { render, staticRenderFns } from "./InputNotificationChannels.vue?vue&type=template&id=7df9f66d"
import script from "./InputNotificationChannels.vue?vue&type=script&lang=js"
export * from "./InputNotificationChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports